import React, { useRef } from 'react';
import styles from './ImageUploader.module.css';

const ImageUploader = ({ images, setImages, max = 3, label = '画像', className }) => {
  const fileInputRef = useRef(null);

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setImages(prev => {
      const merged = [...prev, ...files].slice(0, max);
      return merged;
    });
  };

  const handleAddImageClick = () => {
    if (images.length < max && fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleRemoveImage = (idx) => {
    setImages(prev => prev.filter((_, i) => i !== idx));
  };

  return (
    <div className={styles.imageUploadBlock}>
      <div style={{ marginBottom: 8 }}>
        <span>{label}（最大{max}枚）</span>
      </div>
      <div style={{ marginBottom: 16 }}>
        <button
          type="button"
          className={styles.addImageButton}
          onClick={handleAddImageClick}
          disabled={images.length >= max}
        >
          画像を追加
        </button>
      </div>
      {images.length > 0 && (
        <div className={styles.imagePreviewArea} style={{ marginBottom: 16 }}>
          {images.map((img, idx) => {
            let src = '';
            if (typeof img === 'string') {
              src = img;
            } else if (img instanceof File) {
              src = URL.createObjectURL(img);
            }
            return (
              <div key={idx} className={styles.imagePreviewWrapper}>
                <img
                  src={src}
                  alt={`画像${idx+1}`}
                  className={styles.imagePreview}
                />
                <button
                  type="button"
                  className={styles.deleteImageButton}
                  onClick={() => handleRemoveImage(idx)}
                >
                  ×
                </button>
              </div>
            );
          })}
        </div>
      )}
      <div>
        <input
          type="file"
          accept="image/*"
          multiple
          style={{ display: 'none' }}
          ref={fileInputRef}
          onChange={handleImageChange}
        />
      </div>
    </div>
  );
};

export default ImageUploader;
